import { render, staticRenderFns } from "./time-box.vue?vue&type=template&id=850e321a&scoped=true&"
import script from "./time-box.vue?vue&type=script&lang=js&"
export * from "./time-box.vue?vue&type=script&lang=js&"
import style0 from "./time-box.vue?vue&type=style&index=0&id=850e321a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850e321a",
  null
  
)

export default component.exports